export const GAME_W = 1920
export const GAME_H = 1080
export const TILE = 32

export const CAMERA = {
  lerpX: 0.12,
  lerpY: 0.12
}
